<div class="evaluation">
  <div class="card">
    <div class="card-header card-no-border">
      <div class="header-top">
        <h5 class="m-0">{{ 'Recent Evaluations' | translate }}</h5>
        <!-- Optional Dropdown for date selection can be uncommented if needed
        <div class="card-header-right-icon">
          <div class="dropdown">
            <button class="btn dropdown-toggle" type="button" (click)="toggle()">{{ 'Today' | translate }}</button>
            <div class="dropdown-menu dropdown-menu-end" [class.show]="show">
              <a class="dropdown-item" href="#">{{ 'Today' | translate }}</a>
              <a class="dropdown-item" href="#">{{ 'Tomorrow' | translate }}</a>
              <a class="dropdown-item" href="#">{{ 'Yesterday' | translate }}</a>
            </div>
          </div>
        </div>
        -->
      </div>
    </div>
    <div class="card-body pt-0">
      <span class="help-icon fas fa-info-circle"
        ngbTooltip="✨ This is a cute tooltip! ✨"
        placement="top"
        container="body"></span>
      <div class="evaluation-table table-scrollable table-responsive">
        <table class="table table-bordernone">
          <tbody *ngIf="data.data.length > 0; else noDataTemplate">
            <tr *ngFor="let item of data.data">
              <td><img class="img-fluid rounded-circle" src="{{item.image.url}}" alt="user"></td>
              <td class="img-content-box">
                <a class="d-block f-w-500" href="user-profile.html">{{item.employee_name}}</a>
                <span class="f-light">{{item.created_at}}</span>
              </td>
              <td class="text-end">
                <p class="m-0">{{item.comments}}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #noDataTemplate>
          <tr>
            <td colspan="3" class="text-center">
              <p>{{ 'No data found' | translate }}</p>
            </td>
          </tr>
        </ng-template>
      </div>
    </div>
  </div>
</div>
